"use client";

import { WorkplaceRequestShareLinksParams } from "@gettactic/api";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api/api";

export const useWorkplaceRequestShareLinksKey = "workplaceRequestShareLinks";

/**
 * List the guest share links created for a workplace request. Gate the query on
 * `enabled` so it only runs for viewers with `capabilities.can_share` and while
 * the sharing UI is open.
 */
export function useWorkplaceRequestShareLinks(
  ticketId: string,
  params: WorkplaceRequestShareLinksParams = {},
  options: { enabled?: boolean } = {}
) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: [useWorkplaceRequestShareLinksKey, ticketId, params],
    queryFn: async () => {
      const result = await api.client.workplaceRequests.getShareLinks(
        ticketId,
        params
      );
      return result.result;
    },
    enabled: enabled && !!ticketId
  });
}
